import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';

type CheckoutOutcomeUi = Extract<ChatUi, { kind: 'checkout_outcome' }>;

/** Entrada de catálogo do `checkout_outcome` — DATA-ONLY: o host lê o desfecho
 *  pelo `challengeId` e o card de checkout é quem o mostra. */
export const checkoutOutcomeEntry: GenUiEntry<CheckoutOutcomeUi> = {
  kind: 'checkout_outcome',
  slot: 'chat',
  render: () => null,
};
